import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';

const Highlight = ({
  className,
  title,
  text,
  link,
  image,
}) => (
  <div className={className}>
    {image}
    <Inner>
      <Title>{title}</Title>
      <Text>{text}</Text>
      <Button link to={link}>Lees verder</Button>
    </Inner>
  </div>
);

const Title = styled.h2`
  margin: 0 0 1rem 0;
  color: inherit;
  font-size: 1.75rem;
  text-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
`;

const Text = styled.p`
  margin: 0 0 1rem 0;
  color: inherit;
  line-height: ${({ theme }) => theme.baseLineHeight};
  text-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
`;

const Inner = styled.div`
  z-index: 2;
  height: 100%;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.8));
`;

export default styled(Highlight)`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  background-color: ${({ theme }) => theme.grayDarkColor};
  color: white;
  flex-grow: 1;

  &:first-child {
    margin-bottom: ${({ theme }) => theme.grid.columnGap};
  }

  .gatsby-image-wrapper {
    position: absolute !important;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  ${Button} {
    margin-top: auto;
  }
`;
